import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-058d231c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-4 mb-4" }
const _hoisted_2 = { class: "container container-xs px-5 py-5 h-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "試験終了")
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "basic-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, "問題"),
  /*#__PURE__*/_createElementVNode("th", null, "結果"),
  /*#__PURE__*/_createElementVNode("th", null, "あなたの答え"),
  /*#__PURE__*/_createElementVNode("th", null, "正解")
], -1))
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_11 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_12 = { class: "my-4" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "btn btn-secondary"
}, "TOPへ戻る", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (q, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_8, "問" + _toDisplayString(i + 1), 1),
                _createElementVNode("td", _hoisted_9, [
                  (_ctx.displayAnswer(q, q.currentChoice, q.answer))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "正解"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "不正解"))
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.displayStr(q, q.currentChoice)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.displayStr(q, q.answer)), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("a", {
          href: `/pdf/${_ctx.shikenId}.pdf`,
          class: "btn btn-secondary",
          style: {"display":"inline-block","margin-right":"1em"},
          target: "_blank"
        }, "解説PDF", 8, _hoisted_13),
        _hoisted_14
      ])
    ])
  ]))
}